"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TimeInput;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_mask_text_1 = require("react-native-mask-text");
const react_native_paper_1 = require("react-native-paper");
const react_native_paper_dates_1 = require("react-native-paper-dates");
const Theme_1 = require("../Theme");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
function TimeInput(props) {
    const [visible, setVisible] = react_1.default.useState(false);
    const setModalVisibility = () => {
        if (!visible) {
            setVisible(true);
        }
        else {
            setVisible(false);
        }
    };
    const onDismiss = () => {
        setVisible(false);
    };
    const onConfirm = (data) => {
        setVisible(false);
        const postMeridiem = data.hours >= 12;
        let hours = data.hours > 12 ? data.hours - 12 : data.hours;
        if (hours == 0) {
            hours = 12;
        }
        let hoursString = hours < 10 ? `0${hours}` : `${hours}`;
        let minutesString = data.minutes < 10 ? `0${data.minutes}` : `${data.minutes}`;
        const time = `${hoursString}:${minutesString} ${postMeridiem ? 'PM' : 'AM'}`;
        props.onChangeText(time);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { error: props.error, ...props, keyboardType: "default", right: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput.Icon, { icon: ({ color, size }) => ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Clock, color: color, size: 16 })), onPress: () => setModalVisibility() }), render: (props) => ((0, jsx_runtime_1.jsx)(react_native_mask_text_1.MaskedTextInput, { ...props, defaultValue: "", mask: '99:99 AA', onChangeText: (formatted) => {
                        props.onChangeText(formatted);
                    } })) }), (0, jsx_runtime_1.jsx)(react_native_paper_dates_1.TimePickerModal, { visible: visible, onDismiss: onDismiss, onConfirm: onConfirm })] }));
}
;
